import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

function valuetext(value: number) {
  return `${value}°C`;
}

export default function RangeSlider({targetValue, type, defaultValue, advancedOptionsState, setAdvancedOptionsState}) {
    const [value, setValue] = React.useState<number[]>([targetValue - defaultValue[0], targetValue+defaultValue[1]]);
    const handleChange = (event: Event, newValue: number | number[]) => {
        setValue(newValue as number[]);
        updateTolerance();
    };

    const updateTolerance = () => {
        switch(type){
            case 'ph':
                advancedOptionsState.tolerances.ph = [targetValue-value[0], value[1]-targetValue]; 
                setAdvancedOptionsState(advancedOptionsState)
                break;
            case 'ec':
                advancedOptionsState.tolerances.ec = [targetValue-value[0], value[1]-targetValue]; 
                setAdvancedOptionsState(advancedOptionsState)
                break;
            case 'temperature':
                advancedOptionsState.tolerances.temperature = [targetValue-value[0], value[1]-targetValue]; 
                setAdvancedOptionsState(advancedOptionsState)
                break;
            case 'humidity':
                advancedOptionsState.tolerances.humidity = [targetValue-value[0], value[1]-targetValue]; 
                setAdvancedOptionsState(advancedOptionsState)
                break;
            case 'water_flow_rate':
                advancedOptionsState.tolerances.water_flow_rate = [targetValue-value[0], value[1]-targetValue]; 
                setAdvancedOptionsState(advancedOptionsState)
        }
    }
    const getMin = () =>{
        switch(type){
            case 'ph':
                return targetValue-.5
            case 'ec':
                return targetValue-1.5
            case 'temperature':
                return targetValue-5
            case 'humidity':
                return targetValue-15
            case 'water_flow_rate':
                return targetValue-5
            case 'moisture':
                return targetValue-5
        }
    }
    const getMax = () =>{
        switch(type){
            case 'ph':
                return targetValue+1
            case 'ec':
                return targetValue+1.5
            case 'temperature':
                return targetValue+5
            case 'humidity':
                return targetValue+15
            case 'water_flow_rate':
                return targetValue+5
            case 'moisture':
                return targetValue+5
        }
    }
    const getStep = () =>{
        switch(type){
            case 'ph':
                return .02
            case 'ec':
                return .02
            case 'temperature':
                return 1
            case 'humidity':
                return 1
            case 'water_flow_rate':
                return 1
            case 'moisture':
                return 1
        }
    }

    return (
        <Box>
        <Slider
            min={getMin()}
            max={getMax()}
            step={getStep()}
            marks={[{value:targetValue, label:String(targetValue)}]}
            value={value}
            onChange={handleChange}
            valueLabelDisplay="auto"
            getAriaValueText={valuetext}
            sx={{
                color: '#34d399',
                '& .MuiSlider-thumb': { borderColor: '#059669' },
                '& .MuiSlider-track': { border: 'none' },
            }}
        />
        </Box>
    );
}